import {
  type QuoteRequest,
  type QuoteResponse,
  quoteHash,
  verifyQuoteSignature,
} from "@defuse-protocol/one-click-sdk-typescript"

export { quoteHash, verifyQuoteSignature }

// Callers branch on this stable code rather than user-facing copy.
export const QUOTE_SIGNATURE_INVALID_CODE = "ERR_QUOTE_SIGNATURE_INVALID"

export const QUOTE_SIGNATURE_INVALID_MESSAGE =
  "Quote verification failed: we couldn't confirm this quote is authentic, so your request was stopped for your safety. Please try again, or contact support if this continues."

export function isQuoteSignatureError(error: string | undefined): boolean {
  return error === QUOTE_SIGNATURE_INVALID_CODE
}

// Preserves error identity across throw boundaries.
export class QuoteSignatureError extends Error {
  constructor() {
    super(QUOTE_SIGNATURE_INVALID_CODE)
    this.name = "QuoteSignatureError"
  }
}

/** Reject an unverifiable quote before it can be used or funded. */
export function verifyQuoteResult<
  R extends
    | { ok: QuoteResponse }
    | { err: string; correlationId?: string; originalRequest?: QuoteRequest },
>(result: R): R | { err: string } {
  if ("ok" in result && !verifyQuoteSignature(result.ok)) {
    return { err: QUOTE_SIGNATURE_INVALID_CODE }
  }
  return result
}
